import { servicePerformanceActions } from './servicePerformanceActionCreator';
const initialState = {
  isFetching: false,
  clientList: [],
  isFetchingChartsData: false,
  isFetchingBusinessOverviewData: false,
  isFetchingNetServiceLevelData: false,
  isFetchingNslBreakupData: false,
  chartsData: {},
  nslServiceChartsData: {},
  nslServiceErrorMessage: null,
  nslBreakupChartsData: {},
  nslBreakupErrorMessage: null,
  businessOverViewChartsData: {},
  businessOverViewErrorMessage: null,
  rpClientList: []
};

const servicePerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case servicePerformanceActions.SET_CLIENT_LIST:
      const dropdown = [];
      if (action.payload.length > 0) {
        action.payload.map(option =>
          dropdown.push({
            id: option.id,
            key: option.billingName,
            value: option.clientCode,
            organizationType: option.organizationType,
            organizationCode: option.organizationCode,
            organizationName: option.organizationName
          })
        );
      }
      return { ...state, clientList: dropdown };

    case servicePerformanceActions.SET_IS_FETCHING_CLIENT_LIST:
      return { ...state, isFetching: action.payload };

    case servicePerformanceActions.RESET_CLIENT_LIST_AND_FETCHING:
      return { ...state, isFetching: false, clientList: [] };
    case servicePerformanceActions.SET_NSL_SERVICE_DATA: {
      return {
        ...state,
        nslServiceChartsData: action.payload
      };
    }
    case servicePerformanceActions.SET_NSL_BREAKUP_DATA: {
      return {
        ...state,
        nslBreakupChartsData: action.payload
      };
    }
    case servicePerformanceActions.SET_BUSINESS_OVERVIEW_DATA: {
      return {
        ...state,
        businessOverViewChartsData: action.payload
      };
    }
    case servicePerformanceActions.SET_NSL_SERVICE_ERROR_MESSAGE: {
      return {
        ...state,
        nslServiceErrorMessage: action.payload.errorMessage
      };
    }
    case servicePerformanceActions.SET_NSL_BREAKUP_ERROR_MESSAGE: {
      return {
        ...state,
        nslBreakupErrorMessage: action.payload.errorMessage
      };
    }
    case servicePerformanceActions.SET_BUSINESS_OVERVIEW_ERROR_MESSAGE: {
      return {
        ...state,
        businessOverViewErrorMessage: action.payload.errorMessage
      };
    }
    case servicePerformanceActions.SET_IS_FETCHING_NSL_BREAKUP_DATA:
      return { ...state, isFetchingNslBreakupData: action.payload };
    case servicePerformanceActions.SET_IS_FETCHING_NET_SERVICE_LEVEL_DATA:
      return { ...state, isFetchingNetServiceLevelData: action.payload };
    case servicePerformanceActions.SET_IS_FETCHING_BUSINESS_OVERVIEW_DATA:
      return { ...state, isFetchingBusinessOverviewData: action.payload };
    case servicePerformanceActions.RESET_CHARTS_DATA_AND_FETCHING:
      return {
        ...state,
        isFetchingNetServiceLevelData: false,
        isFetchingNslBreakupData: false,
        isFetchingBusinessOverviewData: false,
        nslServiceChartsData: {},
        nslBreakupChartsData: {},
        businessOverViewChartsData: {},
        nslBreakupErrorMessage: null,
        nslServiceErrorMessage: null,
        businessOverViewErrorMessage: null
      };

    case servicePerformanceActions.SET_RP_CLIENT_LIST:
      const rpDropdown = [];
      if (action.payload.length > 0) {
        action.payload.map(option =>
          rpDropdown.push({
            id: option.id,
            key: option.businessPartnerName,
            value: option.businessPartnerCode,
            userId: option.userDTO.id,
            organizationType: 'RP'
          })
        );
      }
      return { ...state, rpClientList: rpDropdown };

    case servicePerformanceActions.RESET_RP_CLIENT_LIST:
      return { ...state, rpClientList: [] };

    default: {
      return state;
    }
  }
};

export default servicePerformanceReducer;
